import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getAccounts, AccountStatus, App } from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { isPstFileMailboxInfo } from 'owa-client-types/lib/PstFileMailboxInfo';
import { isPublicFolderMailboxInfo } from 'owa-client-types/lib/PublicFolderMailboxInfo';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';

/**
 * Determines whether the "All mailboxes" search scope option should be shown.
 *
 * This scope is Monarch-only. Having more than one mail account configured is a Monarch-only
 * scenario, so the presence of multiple accounts is used to gate the option to Monarch. The
 * 'sea-multiAccountSearch' flight acts as the rollout/kill switch.
 *
 * The scope is not applicable when searching within a PST file, the Unified Inbox (UIB), or a
 * public folders mailbox, so it is hidden for those mailbox contexts for now.
 */
export default function shouldShowAllMailboxesScope(selectedMailboxInfo?: MailboxInfo): boolean {
    if (
        selectedMailboxInfo &&
        (isPstFileMailboxInfo(selectedMailboxInfo) ||
            isPublicFolderMailboxInfo(selectedMailboxInfo) ||
            isUnifiedInboxMailboxInfo(selectedMailboxInfo))
    ) {
        return false;
    }

    return (
        isGlobalFeatureEnabled('sea-multiAccountSearch') &&
        getAccounts(AccountStatus.Completed, App.Mail).length > 1
    );
}
